module.exports = __webpack_public_path__ + "img/livepen2025_01.3b25fb08.jpg";